var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import throttleByRaf from '../_util/throttleByRaf';
import cs from '../_util/classNames';
import { ConfigConsumer } from '../ConfigProvider';
import { on, off } from '../_util/dom';
import ResizeObserver from '../_util/resizeObserver';
import { isWindow, isUndefined, isFunction } from '../_util/is';
function getContainerReact(target) {
    return isWindow(target)
        ? {
            top: 0,
            bottom: window.innerHeight,
        }
        : target.getBoundingClientRect();
}
var Affix = /** @class */ (function (_super) {
    __extends(Affix, _super);
    function Affix(props) {
        var _this = _super.call(this, props) || this;
        _this.updatePosition = throttleByRaf(function () {
            _this.setState({
                placeholderStyle: {},
                styles: {},
            }, _this.updateState);
        });
        _this.handleScroll = throttleByRaf(function () {
            _this.setState({
                placeholderStyle: {},
                styles: {},
            }, _this.updateState);
        });
        _this.updateState = function () {
            var _a = _this.props, offsetTop = _a.offsetTop, offsetBottom = _a.offsetBottom, onChange = _a.onChange;
            var offsetType = isUndefined(offsetBottom) ? 'top' : 'bottom';
            if (!_this.fixWrapper || !_this.container) {
                return;
            }
            var affixRect = _this.fixWrapper.getBoundingClientRect();
            var containerRect = getContainerReact(_this.container);
            var status = _this.state.status;
            var newState = {};
            if (offsetType === 'top') {
                var isFixed = affixRect.top - containerRect.top < (offsetTop || 0);
                newState = {
                    status: isFixed,
                    placeholderStyle: {
                        width: _this.fixWrapper.offsetWidth,
                        height: _this.fixWrapper.offsetHeight,
                    },
                    styles: isFixed
                        ? {
                            position: 'fixed',
                            top: containerRect.top + (offsetTop || 0),
                        }
                        : {},
                };
            }
            else {
                var isFixed = containerRect.bottom - affixRect.bottom < (offsetBottom || 0);
                newState = {
                    status: isFixed,
                    placeholderStyle: {
                        width: _this.fixWrapper.offsetWidth,
                        height: _this.fixWrapper.offsetHeight,
                    },
                    styles: isFixed
                        ? {
                            position: 'fixed',
                            bottom: window.innerHeight - containerRect.bottom + (offsetBottom || 0),
                        }
                        : {},
                };
            }
            _this.setState(__assign({}, newState));
            if (newState.status !== status) {
                isFunction(onChange) && onChange(!!newState.status);
            }
        };
        _this.renderAffix = function (_a) {
            var _b;
            var getPrefixCls = _a.getPrefixCls;
            var _c = _this.props, children = _c.children, className = _c.className, style = _c.style;
            var _d = _this.state, status = _d.status, styles = _d.styles, placeholderStyle = _d.placeholderStyle;
            var prefixCls = getPrefixCls('affix');
            var classNames = cs((_b = {},
                _b["" + prefixCls] = styles && styles.position === 'fixed',
                _b));
            return (React.createElement(ResizeObserver, { onResize: _this.updatePosition },
                React.createElement("div", { className: cs(className), style: style, ref: function (ref) {
                        _this.fixWrapper = ref;
                    } },
                    status && React.createElement("div", { style: __assign({}, placeholderStyle) }),
                    React.createElement("div", { className: classNames, style: __assign(__assign({}, styles), (status ? placeholderStyle : {})) },
                        React.createElement(ResizeObserver, { onResize: _this.updatePosition }, children || React.createElement("span", null))))));
        };
        _this.state = {
            status: false,
            placeholderStyle: {},
            styles: {},
        };
        return _this;
    }
    Affix.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, target = _a.target, targetContainer = _a.targetContainer;
        if (!this.container) {
            this.timer = setTimeout(function () {
                if (target) {
                    _this.container = target();
                    on(_this.container, 'scroll', _this.handleScroll);
                    on(_this.container, 'resize', _this.updatePosition);
                }
                _this.updatePosition();
            });
        }
        if (this.container !== window && targetContainer && targetContainer()) {
            on(targetContainer(), 'scroll', this.updatePosition);
        }
    };
    Affix.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
        var targetContainer = this.props.targetContainer;
        if (this.container) {
            off(this.container, 'scroll', this.handleScroll);
            off(this.container, 'resize', this.updatePosition);
        }
        if (!isWindow(this.container) && targetContainer && targetContainer()) {
            off(targetContainer(), 'scroll', this.updatePosition);
        }
    };
    Affix.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderAffix);
    };
    Affix.displayName = 'Affix';
    Affix.propTypes = {
        offsetTop: PropTypes.number,
        offsetBottom: PropTypes.number,
        onChange: PropTypes.func,
        target: PropTypes.func,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        style: PropTypes.object,
    };
    Affix.defaultProps = {
        offsetTop: 0,
        target: function () { return window; },
        onChange: function () { },
    };
    return Affix;
}(Component));
export default Affix;
